import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const VeteransPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Veterans | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Veterans overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>Veterans</h1>
        <p>Welcome to the veterans page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default VeteransPage
